<template>
    <PublishByEoPanel v-if="showEoPublishPanel" v-bind="$attrs" v-on="$listeners" />
    <PublishPanel v-else-if="showStaffPublishPanel" v-bind="$attrs" v-on="$listeners" />
    <div v-else>Access Denied</div>
</template>

<script>
import PublishByEoPanel from '@/components/event/PublishByEoPanel.vue';
import PublishPanel from '@/components/event/PublishPanel.vue';
import { globalParam } from '@/helpers/globals';
import { userIsStaff } from '@/helpers/auth';

export default {
    name: 'EventEditPublish',
    components: { PublishPanel, PublishByEoPanel },

    computed: {
        showEoPublishPanel() {
            return !globalParam('event_review_by_staff') && !userIsStaff();
        },
        showStaffPublishPanel() {
            return userIsStaff();
        },
    },

    mounted() {
        // we emit a "valid" input value, as we need to indicate "everything ok" to the parent component:
        this.$emit('input', true);
    },
};
</script>
